// IMPORTANT: Keep these IDs synced with the 'crop.___' keys in the i18n json files

export const OTHER_CROP_CODE = 'other';
export const COTTON_CROP_CODE = 'cotton';
export const SILAGE_CORN_CROP_CODE = 'corn-silage';
export const SUGARCANE_CROP_CODE = 'sugarcane';

export const UNKOWN_PRODUCT_TYPE = 'unknown';
